module.exports = __webpack_public_path__ + "static/media/DEV00905-Bearbeitet.c294c322.jpg";